export default "__VITE_ASSET__cd235f71__"